import type { GraphQLError } from 'graphql';

/**
 * Проверяет, что ошибка является GraphQLError.
 *
 * @param error - Значение неизвестного типа.
 * @returns true, если error является GraphQLError.
 */
export const isGraphQLError = (error: unknown): error is GraphQLError => {
	return !!error && typeof error === 'object' && 'message' in error && typeof (error as any).message === 'string';
};

/**
 * Проверяет, что ошибка является массивом GraphQLError.
 *
 *
 * @param error - Значение неизвестного типа.
 * @returns true, если непустой массив GraphQLError.
 */
export const isGraphQLErrorArray = (error: unknown): error is GraphQLError[] => {
	return Array.isArray(error) && error.length > 0 && isGraphQLError(error[0]);
};
